<template>
  <v-card color="primary" class="rounded-sm">
    <v-card-text>
      <v-container v-if="armaPersonal">
        <v-row>
          <v-col cols="12">
            <div class="text-caption mb-1">Fecha de asignación</div>
            <div class="text-body-1 text--primary">{{ armaPersonal.fechaAsignado }}</div>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <div class="text-caption mb-1">Comentario</div>
            <div v-for="(linea, index) in comentarioLineas" :key="index" class="text-body-1 text--primary">
              {{ linea }}
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <div class="text-body-2 text--secondary">No hay información disponible.</div>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    armaPersonal: {
      type: Object,
      default: null,
    },
  },
  computed: {
    comentarioLineas() {
      if (!this.armaPersonal?.comentario) return []
      return this.armaPersonal.comentario.split(/\r\n|\n/)
    },
  },
}
</script>
